<dx-popup
  #dlgSalesTransactionList
  [minWidth]="1085"
  [width]="1085"
  maxHeight="940"
  [showTitle]="true"
  title="Sales Transaction List"
  [resizeEnabled]="false"
  [dragEnabled]="false"
  [showCloseButton]="true"
  [hideOnOutsideClick]="false"
  [(visible)]="popupVisible"
  (onShown)="onShown($event)"
  (onHidden)="onHidden($event)"
>
  <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="closeBtnOptions"> </dxi-toolbar-item>
  <dx-data-grid
    id="salesTransactionListGrid"
    [dataSource]="dataSource"
    [allowColumnResizing]="false"
    [allowColumnReordering]="false"
    [columnAutoWidth]="true"
    height="calc(100% - 92px)"
  >
    <dxo-editing [allowUpdating]="false" [allowAdding]="false" [allowDeleting]="false" [allowResizing]="false">
    </dxo-editing>
    <dxo-paging [enabled]="false"></dxo-paging>
    <dxo-scrolling
      mode="virtual"
      columnRenderingMode="virtual"
      rowRenderingMode="virtual"
      showScrollbar="always"
      useNative="false"
      preloadEnabled="true"
    ></dxo-scrolling>
    <dxo-filter-row [visible]="false"></dxo-filter-row>
    <dxo-header-filter [visible]="false"></dxo-header-filter>
    <dxo-group-panel [visible]="false"></dxo-group-panel>
    <dxo-search-panel [visible]="false"></dxo-search-panel>

    <dxi-column
      dataField="TransactionDateTime"
      dataType="date"
      caption="Date & Time"
      format="d MMM yyyy HH:mm"
      sortIndex="1"
      sortOrder="desc"
      [width]="130"
      [allowSorting]="false"
    >
    </dxi-column>
    <dxi-column dataField="BranchName" caption="Branch" [width]="175" [allowSorting]="false"> </dxi-column>
    <dxi-column dataField="Client" caption="Client" [width]="175" [allowSorting]="false"> </dxi-column>
    <dxi-column dataField="ProductDetail" caption="Item" [width]="250" [allowSorting]="false"></dxi-column>
    <dxi-column dataField="ProductQuantity" caption="Qty" [width]="38" [allowSorting]="false"> </dxi-column>
    <dxi-column
      dataField="ProductTotal"
      [format]="{ style: 'currency', currency: 'GBP', useGrouping: true }"
      caption="Paid"
      [width]="80"
      [allowSorting]="false"
    >
    </dxi-column>
    <dxi-column dataField="PaymentMethod" caption="Payment" [width]="118" [allowSorting]="false"> </dxi-column>
    <dxi-column dataField="TransactionType" caption="Type" [width]="55" [allowSorting]="false"> </dxi-column>
  </dx-data-grid>

  <dx-data-grid
    [height]="72"
    id="totalsGrid"
    [dataSource]="summaryTotals"
    [columns]="['TotalProduct', 'TotalSession', 'TotalCourse', 'TotalCard', 'TotalCash']"
    [showBorders]="true"
    [loadPanel]="{ enabled: false }"
  >
  </dx-data-grid>
</dx-popup>
